// src/features/townBudget/components/programs/Program_DebtServiceAndTransfersOut.jsx
import React from "react";
import { ProgramBudget } from "../../../../budget/model/program/ProgramBudget.jsx";

/**
 * Debt Service & Transfers Out
 *
 * Backed by Firestore docId:
 *   expenditures_debt_transfers_out
 *
 * NOTE:
 * This doc is structured as nested blocks:
 *   - "Debt Transfers Out" (multiple line items)
 *   - "Debt Service" (single line item)
 *
 * fieldDefs use { block: "<Block Name>", key: "<Line Item Name>" }.
 */
export const PROGRAM_DEBT_SERVICE_TRANSFERS_OUT_CONFIG = {
  fullName: "Debt Service & Transfers Out",
  docId: "expenditures_debt_transfers_out",

  fieldDefs: [
    // -------------------------
    // Debt Transfers Out
    // -------------------------
    {
      key: "capitalReserveFund",
      label: "Capital Reserve Fund",
      valueType: "currency",
      sources: [{ block: "Debt Transfers Out", key: "Capital Reserve Fund" }],
      group: "debtTransfersOut",
      defaultVisible: true,
    },
    {
      key: "dogFund",
      label: "Dog Fund",
      valueType: "currency",
      sources: [{ block: "Debt Transfers Out", key: "Dog Fund" }],
      group: "debtTransfersOut",
      defaultVisible: false,
    },
    {
      key: "opebFund",
      label: "OPEB Fund",
      valueType: "currency",
      sources: [{ block: "Debt Transfers Out", key: "OPEB Fund" }],
      group: "debtTransfersOut",
      defaultVisible: true,
    },
    {
      key: "capitalProjectsFund",
      label: "Capital Projects Fund",
      valueType: "currency",
      sources: [{ block: "Debt Transfers Out", key: "Capital Projects Fund" }],
      group: "debtTransfersOut",
      defaultVisible: true,
    },
    {
      key: "sewerOperating",
      label: "Sewer Operating",
      valueType: "currency",
      sources: [{ block: "Debt Transfers Out", key: "Sewer Operating" }],
      group: "debtTransfersOut",
      defaultVisible: false,
    },
    {
      key: "landAcquisition",
      label: "Land Acquisition",
      valueType: "currency",
      sources: [{ block: "Debt Transfers Out", key: "Land Acquisition" }],
      group: "debtTransfersOut",
      defaultVisible: false,
    },
    {
      key: "contingency",
      label: "Contingency",
      valueType: "currency",
      sources: [{ block: "Debt Transfers Out", key: "Contingency" }],
      group: "debtTransfersOut",
      defaultVisible: false,
    },
    {
      key: "pension",
      label: "Pension",
      valueType: "currency",
      sources: [{ block: "Debt Transfers Out", key: "Pension" }],
      group: "debtTransfersOut",
      defaultVisible: false,
    },

    // -------------------------
    // Debt Service
    // -------------------------
    {
      key: "debtService",
      label: "Debt Service",
      valueType: "currency",
      sources: [{ block: "Debt Service", key: "Debt Service" }],
      group: "debtService",
      defaultVisible: true,
    },
  ],

  tables: [
    {
      id: "adopted",
      title: "Debt Service & Transfers Out – Approved",
      sectionKey: "Approved",
      fields: [
        // Debt Transfers Out
        "capitalReserveFund",
        "dogFund",
        "opebFund",
        "capitalProjectsFund",
        "sewerOperating",
        "landAcquisition",
        "contingency",
        "pension",

        // Debt Service
        "debtService",
      ],
      columnStyles: {
        year: { width: "100px", minWidth: "100px" },
        capitalReserveFund: { minWidth: "200px" },
        capitalProjectsFund: { minWidth: "200px" },
        landAcquisition: { minWidth: "170px" },
        sewerOperating: { minWidth: "160px" },
        debtService: { minWidth: "140px" },
      },
    },
    {
      id: "actual",
      title: "Debt Service & Transfers Out – Actual",
      sectionKey: "Actual",
      fields: [
        // Debt Transfers Out
        "capitalReserveFund",
        "dogFund",
        "opebFund",
        "capitalProjectsFund",
        "sewerOperating",
        "landAcquisition",
        "contingency",
        "pension",

        // Debt Service
        "debtService",
      ],
      columnStyles: {
        year: { width: "100px", minWidth: "100px" },
        capitalReserveFund: { minWidth: "200px" },
        capitalProjectsFund: { minWidth: "200px" },
        landAcquisition: { minWidth: "170px" },
        sewerOperating: { minWidth: "160px" },
        debtService: { minWidth: "140px" },
      },
    },
  ],

  chartTitle: "Debt Service & Transfers Out (Actual preferred)",
};

export function ProgramDebtServiceAndTransfersOut(props) {
  return (
    <ProgramBudget
      programId="expenditures_debt_transfers_out"
      config={PROGRAM_DEBT_SERVICE_TRANSFERS_OUT_CONFIG}
      {...props}
    />
  );
}

export default ProgramDebtServiceAndTransfersOut;
